<template>
	<v-container fluid >
		<v-toolbar elevation="1">
			<v-app-bar-nav-icon :to="{ name: 'Dictionaries' }">
				<v-icon large :color="color">{{ icon }}</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>
				<div class="text-h6">{{ title }}</div>
				<div class="text-subtitle-2 font-weight-light">{{ subtitle }}</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<!-- <v-tabs-items v-model="tab">
			<v-tab-item> -->
				<v-card flat>
					<v-card-title>
						<!-- Nutrition -->
						<v-spacer></v-spacer>
						<v-text-field
							v-model="search.table.text"
							append-icon="mdi-magnify"
							label="Search"
							single-line
							hide-details
							@click:append="onSearch"
							@keyup.enter="onSearch"
						></v-text-field>
					</v-card-title>
					<v-card-title>
						<!-- <v-btn text v-for="letter in alphabet_en" :key="letter" :value="letter" class="ma-1"> -->
						<div>
							<v-btn text small v-for="letter in alphabet_en" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
						</div>
						<div>
							<v-btn text small v-for="letter in alphabet_uk" :key="letter" :value="letter" @click="onFilterByLetter(letter)">{{ letter }}</v-btn>
						</div>
						<!-- <v-btn-toggle v-model="selectedLetter" mandatory color="primary" variant="outlined">
							<v-btn text v-for="letter in alphabet_en" :key="letter" :value="letter" class="ma-1">
								{{ letter }}
							</v-btn>
						</v-btn-toggle> -->
					</v-card-title>
					<v-data-table
						:headers="headers"
						:items="items"
						:loading="loading.table"
						loading-text="Loading... Please wait"
					></v-data-table>
				</v-card>
			<!-- </v-tab-item>
		</v-tabs-items> -->
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'DrugDRLZ',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail,
		zConfirmDelete,
	},
	data: () => ({
		title: 'ДРЛЗ',
		//subtitle: 'NFC (National Form Classification)',
		subtitle: 'Державний реєстр лікарських засобів України',
		icon: 'mdi-book-open-variant',
		color: 'green darken-1',
		//loading: false,

		search: {
			table: {
				visible: false,
				text: '',
			},
		},

		loading: {
			table: false,
		},

		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			//{ text: 'Код', value: 'code', sortable: true},
			{ text: 'Торгівельне найменування', value: 'tradeName', sortable: true},
			{ text: 'Міжнародне непатентоване найменування', value: 'internationalName', sortable: true},
			{ text: 'Форма випуску', value: 'releaseForm', sortable: true},
			
			{ text: 'Номер Реєстраційного посвідчення', value: 'registrationNumber', sortable: true},
			{ text: 'Дата початку дії', value: 'dateOfStart', sortable: true},
			{ text: 'Дата закінчення', value: 'dateOfExpiry', sortable: true},
			{ text: 'Заявник', value: 'applicantName', sortable: true},
			{ text: 'Кількість виробників', value: 'manufacturersCount', sortable: true},
			{ text: 'Виробник 1', value: 'manufacturerName1', sortable: true},
			{ text: 'Виробник 2', value: 'manufacturerName2', sortable: true},
			{ text: 'Виробник 3', value: 'manufacturerName3', sortable: true},
			{ text: 'Виробник 4', value: 'manufacturerName4', sortable: true},
			{ text: 'Виробник 5', value: 'manufacturerName5', sortable: true},
			//{ text: 'Рівень', value: 'level', sortable: true},
			{ text: '', value: 'actions', sortable: false },
/*
			id 								BIGINT NOT NULL AUTO_INCREMENT COMMENT 'Unique identifier'
			,uid 							CHAR(36) DEFAULT UUID() COMMENT 'Унікальний ідентифікатор'
			,trade_name 					VARCHAR(1024)  			COMMENT 'Торгівельне найменування'
			,international_name 			VARCHAR(128)  			COMMENT 'Міжнародне непатентоване найменування'
			,release_form					VARCHAR(3072)  			COMMENT 'Форма випуску'
			,dispensing_conditions			VARCHAR(256)  			COMMENT 'Умови відпуску'
			,composition					VARCHAR(3072)  			COMMENT 'Склад (діючі)'
			,pharmacotherapeutic_group		VARCHAR(1024)  			COMMENT 'Фармакотерапевтична група'
			,atc_code_1 					CHAR(7)					COMMENT 'Код АТС 1'
			,atc_code_2 					CHAR(7)					COMMENT 'Код АТС 2'
			,atc_code_3 					CHAR(7)					COMMENT 'Код АТС 3'
			,applicant_name					VARCHAR(256)  			COMMENT 'Заявник: назва українською'
			,applicant_country				VARCHAR(128)  			COMMENT 'Заявник: країна'
			,applicant_address				VARCHAR(128)  			COMMENT 'Заявник: адреса'
			,manufacturers_count			INT  					COMMENT 'Кількість виробників'
			,manufacturer_name_1			VARCHAR(256)  			COMMENT 'Виробник 1: назва українською'
			,manufacturer_country_1			VARCHAR(128)  			COMMENT 'Виробник 1: країна'
			,manufacturer_address_1			VARCHAR(128)  			COMMENT 'Виробник 1: адреса'
			,manufacturer_name_2			VARCHAR(256)  			COMMENT 'Виробник 2: назва українською'
			,manufacturer_country_2			VARCHAR(128)  			COMMENT 'Виробник 2: країна'
			,manufacturer_address_2			VARCHAR(128)  			COMMENT 'Виробник 2: адреса'
			,manufacturer_name_3			VARCHAR(256)  			COMMENT 'Виробник 3: назва українською'
			,manufacturer_country_3			VARCHAR(128)  			COMMENT 'Виробник 3: країна'
			,manufacturer_address_3			VARCHAR(128)  			COMMENT 'Виробник 3: адреса'
			,manufacturer_name_4			VARCHAR(256)  			COMMENT 'Виробник 4: назва українською'
			,manufacturer_country_4			VARCHAR(128)  			COMMENT 'Виробник 4: країна'
			,manufacturer_address_4			VARCHAR(128)  			COMMENT 'Виробник 4: адреса'
			,manufacturer_name_5			VARCHAR(256)  			COMMENT 'Виробник 5: назва українською'
			,manufacturer_country_5			VARCHAR(128)  			COMMENT 'Виробник 5: країна'
			,manufacturer_address_5			VARCHAR(128)  			COMMENT 'Виробник 5: адреса'
			,registration_number			VARCHAR(64)  			COMMENT 'Номер Реєстраційного посвідчення'
			,date_of_start 					VARCHAR(32)  			COMMENT 'Дата початку дії'
			,date_of_expiry 				VARCHAR(32)  			COMMENT 'Дата закінчення'
			,drug_type						VARCHAR(32)  			COMMENT 'Тип ЛЗ'
			,biological_origin				CHAR(3) 				COMMENT 'ЛЗ біологічного походження'
			,plant_origin					CHAR(3)					COMMENT 'ЛЗ рослинного походження'
			,orphan							CHAR(3)					COMMENT 'ЛЗ-сирота'
			,homeopathic					CHAR(3)					COMMENT 'Гомеопатичний ЛЗ'
			,mnn_type						VARCHAR(32)  			COMMENT 'Тип МНН'
			,early_termination_availability	CHAR(3)  				COMMENT 'Дострокове припинення'
			,early_termination_last_day		VARCHAR(32)  			COMMENT 'Дострокове припинення: останній день дії'
			,early_termination_reason		VARCHAR(1024)  			COMMENT 'Дострокове припинення: причина'
			,instructions_url				VARCHAR(256)  			COMMENT 'URL інструкції'
			,expiration_info				VARCHAR(3072)  			COMMENT 'Термін придатності'
			,expiration_value				INT  					COMMENT 'Термін придатності: значення'
			,expiration_unit				VARCHAR(32)  			COMMENT 'Термін придатності: одиниця вимірювання'
			,datecreate 					DATETIME DEFAULT current_timestamp() COMMENT 'Дата створення'
			*/
		],

		items: [],
	}),
	
	computed: {
		//...mapGetters('VehiclePark', [ 'items' ]),
		alphabet_en() {
			const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
			return alphabet
		},

		alphabet_uk() {
			const alphabet = "АБВГҐДЕЄЖЗІЇЙКЛМНОПРСТУФХЦЧШЩЮЯ".split("");
			return alphabet
		},
	},

	created () {
		//this.loadLevel1()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		//--------------------------------------------------------------------

		onSearch() {
			//console.log(this.$options.name, 'loadModels','item1', item1)
			let that = this
			this.loading.table = true
			axios.get('/drug/drlz', { params: { search: this.search.table.text }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.table = false));
		},

		onFilterByLetter(letter){
			//console.log(this.$options.name, 'onFilterByLetter','letter', letter)
			let that = this
			this.loading.table = true
			axios.get('/drug/drlz', { params: { letter: letter }}).then(response => {
				//console.log(that.$options.name, 'loadLevel5','response.data', response.data)
				that.items = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.table = false));
		},
	},
}
</script>